<template>
  <section v-if="isVisible" class="SubscribingStatus">
    <section v-for="plan in plans" :key="plan.key" class="PlanList">
      <div v-if="plan.contentLists.length" class="PlanList-inner">
        <div class="PlanList-titleWrapper">
          <h4 class="PlanList-title" v-text="plan.title"></h4>
        </div>

        <div v-for="list in plan.contentLists" :key="list.key" class="PlanList-listGroup">
          <h5 v-if="list.heading" class="PlanList-listTitle" v-text="list.heading"></h5>

          <ul class="PlanList-list">
            <li
              v-for="content in list.contents"
              :key="content.text"
              class="PlanList-list-item"
              :class="getClassOfPlanContent(content.bullet || 'dot')"
            >
              {{ content.text }}
            </li>
          </ul>
        </div>

        <div v-if="plan.hasInquiryLink" class="PlanList-buttonWrapper">
          <a
            href="https://forms.gle/DfvsVnLB1feBWuXr6"
            target="_blank"
            rel="noopener"
            class="commonButton t-full"
          >
            コンテンツ追加のお問い合わせ
          </a>
        </div>
      </div>

      <p v-if="plan.note" class="SubscribingStatus-note" v-text="plan.note"></p>
    </section>
  </section>
</template>

<script>
import FormItem from '../../mixins/FormItem'

import getClassOfPlanContent from '../../functions/getClassOfPlanContent'

import contentLists from '../../data/contentLists'

export default {
  name: 'SubscribingStatus',
  mixins: [FormItem],
  data() {
    return {
      currentUser: gon.current_user || {},
    }
  },
  computed: {
    contentLists,
    plans() {
      return [
        {
          key: 'subscribed',
          title: '現在ご利用いただけるコンテンツ',
          contentLists: this.subscribedContentLists,
          note: '※Freeコンテンツの提供内容は今後変更される可能性があります。',
        },
        {
          key: 'unsubscribed',
          title: '追加可能なコンテンツ(担当者よりご連絡いたします)',
          contentLists: this.unsubscribedContentLists,
          hasInquiryLink: true,
        },
      ]
    },
    // NOTE: 有料コンテンツはPremiumであれば全機能契約済み、それ以外は一つも契約していないとみなす
    // TODO: 機能売り対応時、判別条件をcurrentPlanRankから各コンテンツの契約状況に変更する
    paidContentsWithContractStatus() {
      return this.isPremium
        ? this.contentLists.paid.map((content) => ({ ...content, isSubscribed: true }))
        : this.contentLists.paid
    },
    subscribedPaidContents() {
      return this.paidContentsWithContractStatus.filter((content) => content.isSubscribed)
    },
    unsubscribedPaidContents() {
      return this.paidContentsWithContractStatus.filter((content) => !content.isSubscribed)
    },
    subscribedContentLists() {
      return this.removeContentsIsEmpty([
        {
          key: 'free',
          heading: 'Freeコンテンツ',
          contents: this.contentLists.free,
        },
      ])
    },
    unsubscribedContentLists() {
      return this.removeContentsIsEmpty([
        {
          key: 'paid',
          contents: this.unsubscribedPaidContents,
        },
      ])
    },
    currentPlanRank() {
      return this.currentUser.plan_rank
    },
    isPremium() {
      return this.currentPlanRank === 4
    },
  },
  methods: {
    getClassOfPlanContent,
    removeContentsIsEmpty(contentLists) {
      return contentLists.filter((list) => list.contents.length)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../css/foundation/vars';
@import '../../css/vue_modules/plan_list';

.SubscribingStatus {
  margin-top: 7.2rem;
  margin-bottom: 12rem;

  &:first-child {
    margin-top: 0;
  }
}

.PlanList {
  margin-top: 2rem;
}

.PlanList-inner {
  border-color: #414141;
}

.PlanList-title {
  padding-right: 2.8rem;
  padding-left: 1rem;
  background: vars.$color-bg-0;
}

.SubscribingStatus-note {
  padding-left: 3.2rem;
  margin-top: 1.4rem;
  font-size: 1.6rem;
  color: #707070;

  a {
    color: vars.$color-btn-accept;
    text-decoration: underline;
    transition: filter 0.2s ease;

    &:hover {
      filter: brightness(1.3);
    }
  }
}
</style>
